import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Upload } from './upload';

@Injectable()
export class UploadService {

  constructor(
    private afs: AngularFirestore,
  ) { }
  private uploadTask: firebase.storage.UploadTask;
  /**
   * Update the user information on Firestore
   * @param userUid
   * return the current uid from the user
   * @param upload
   * return the current upload object
   */
  uploadFile(userUid: string, upload: Upload) {
    const storageRef = firebase.storage().ref();
    const uploadTask = storageRef.child(`${userUid}/profilePicture/${upload.file.name}`).put(upload.file);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot: any) => {
      upload.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    },
    (err) => {
  
    },
    () => {
      upload.url = uploadTask.snapshot.downloadURL;
      upload.name = upload.file.name;
      
      this.updateUserData(userUid, upload);
    });
  }
  /**
   * Update the user information on Firestore
   * @param userUid
   * return the current uid from the user
   * @param upload
   * return the current upload object
   */
  private updateUserData(userUid: string, upload: Upload) {
    const userRef = this.afs.doc(`users/${userUid}`);
    const data = {
      photoURL: upload.url
    };
    return userRef.update(data);
  }


}
